import { render, staticRenderFns } from "./IntellectualProperty.vue?vue&type=template&id=9514d594"
import script from "./IntellectualProperty.vue?vue&type=script&lang=js"
export * from "./IntellectualProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports